<ngx-spinner bdColor = "rgb(3 86 158 / 80%)" size = "medium" color = "#fff" type = "ball-scale-ripple-multiple" [fullScreen] = "true"><p style="color: white" > Laster... </p></ngx-spinner>
